export default class LocalStorage
{
    constructor(namespace, name) {
        this.key = namespace + '_' + name;
        this.namespace = namespace;
        this.storage = localStorage;
    }

    /**
     * Get payload
     * @returns {string|null}
     */
    get() {
        if (this.storage === undefined) {
            return null;
        }

        let payload = this.storage.getItem(this.key);
        return payload === null ? null : this._expire(JSON.parse(payload));
    }

    /**
     * Deals with items having an expiration .
     * Polymorphic data can be stored, this function handles both simple items and complex data with expiracy
     * @param {*} item 
     * @returns {string|,null}
     */
    _expire(item) {
        // does the item have an expiration policy ?
        if (item.expiry != undefined) {
            const now = new Date()
            // compare the expiry time of the item with the current time
            if (now.getTime() > item.expiry) {
                // If the item is expired, delete the item from storage
                // and return null
                this.delete();
                return null
            }
            return item.payload;
        }
        return item;
    }

    /**
     * Set payload storage
     *
     * @param payload
     * @returns {LocalStorage}
     */
    set(payload) {
        return this._set(payload);
    }

    /**
     * 
     * @param  payload 
     * @param  ttl: the expiration in milliseconds (!!)
     * @returns {LocalStorage}
     */
    setex(payload, ttl) {
        const now = new Date()
        // the data we set is an object which contains the original value
        // as well as the time when it's supposed to expire
        return this._set({
            payload: payload,
            expiry: now.getTime() + ttl
        });
    }

    _set(payload) {
        if (this.storage === undefined) {
            return this;
        }
        try {
            this.storage.setItem(this.key, JSON.stringify(payload));
        } catch (e) {
            //session storage is full, clear namespace
            this.deleteNamespace();
            this.storage.setItem(this.key, JSON.stringify(payload));
        }
        return this;
    }


    /**
     *
     */
    deleteNamespace() {
        if (this.storage === undefined) {
            return;
        }

        let length = this.storage.length;
        for (let i = (length - 1); i >= 0 ; i--) {
            let key = this.storage.key(i);
            if (key.substr(0, this.namespace.length + 1) == (this.namespace + '_')) {
                this.storage.removeItem(key);
            }
        }
    }

    /**
     * Delete storage
     * @returns {LocalStorage}
     */
    delete() {
        if (this.storage === undefined) {
            return this;
        }

        this.storage.removeItem(this.key);
        return this;
    }
}